import { WorkOSUser } from '@/components/UserProfileSettingDetail'
import showToastNotification from '@/hooks/useShowToast'
import useUserPermissions from '@/hooks/useUserPermissions'
import { trpc } from '@/utils/trpc'
import { useEffect, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'

const useEditTeamName = () => {
  const [editTeamNameMode, setEditTeamNameMode] = useState<boolean>(false)
  const [newTeamName, setNewTeamName] = useState<string>('')
  const utils = trpc.useUtils()
  const { userTeams, isFetchingUserTeams } = useUserPermissions()
  const [user] = useLocalStorage<WorkOSUser | undefined>('_wos_user', undefined)

  const { mutate: editTeam, isPending: isEditingTeam } = trpc.editTeam.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: `Success`,
        description: `Team name updated successfully!`,
      })
      setEditTeamNameMode(false)
      await utils.getUserTeams.invalidate()
    },
    onError: () => {
      showToastNotification('error', {
        message: `Edit Failed`,
        description: `Unfortunately, we couldn't update the team name. Please try again later.`,
      })
      setNewTeamName(userTeams?.find((team) => team.id == user?.teamId)?.name || '')
      setEditTeamNameMode(false)
    },
  })

  useEffect(() => {
    if (userTeams && userTeams.length > 0) {
      setNewTeamName(userTeams?.find((team) => team.id == user?.teamId)?.name || '')
    }
  }, [userTeams])
  return {
    editTeamNameMode,
    setEditTeamNameMode,
    newTeamName,
    setNewTeamName,
    userTeams,
    isFetchingUserTeams,
    user,
    editTeam,
    isEditingTeam,
  }
}

export default useEditTeamName
